import { useContext, useEffect, useState } from 'react'
import { getAuth, createUserWithEmailAndPassword, AuthError, signInWithEmailAndPassword } from 'firebase/auth'
import FormInformation from 'components/form-information'
import ProfileService from 'services/profile-services'
import utmServices from 'services/utm-services'
import { AxiosError } from 'axios'
import { TextEmail, TitleEmail } from 'views/mail-verify/text.style'
import Button from 'components/button'
import textServices from 'services/text-services'
import ErrorView from 'components/error-view'
import { getBirthdayLocal } from 'utilities/birthday'
import useRouter from 'hooks/use-router'
import { useSession } from 'contexts/session-context'
import useRedirect from 'hooks/use-redirect'
import { LoaderContext } from '../../contexts/loader-context'
import Welcome from './components/welcome'

const auth = getAuth()

const SignUp = () => {
  const { setLoad } = useContext(LoaderContext)
  const [, { setSession, setUser }] = useSession()
  const [{ url }, { redirect }] = useRedirect();
  const [otp, setOtp] = useState(false)
  const [done, setDone] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [credentials, setCredentials] = useState(null)
  const [birthday, setBirthday] = useState(null)
  const { push } = useRouter()

  useEffect(() => {
    setBirthday(getBirthdayLocal())
  }, [])

  const handleLogin = async () => {
    setLoad(true)
    try {
      gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'LOGIN - Iniciar sesión', value: 'Email' })
      const credentials = await signInWithEmailAndPassword(auth, email, password)
      const loginResponse = await ProfileService.signInWithEmailAndPassword({ credentials })
      setSession(credentials)
      setUser(loginResponse.data)
      const { nickName, birthday, genre, genreId } = loginResponse.data
      gtag("event", "login", {
        method: "Email"
      });
      if (url) {
        return redirect()
      } else if (!nickName || !birthday || (!genre || !genreId)) {
        return push('/information/update')
      }
      push('/home')
    } catch (error) {
      if (error?.code) {
        return setError(error.code)
      } else if ((error as AxiosError).isAxiosError) {
        return setError((error as AxiosError).response?.data.code)
      }
    } finally {
      setLoad(false)
    }
  }

  const handleConfirm = async (data) => {
    setLoad(true)
    try {
      const response = await ProfileService.otpVerifyEmail({ code: data.otp, credentials })
      if (response?.status === 200) {
        gtag('event', 'email_verificado', {
          event_label: 'Registro - Email',
          method: "Email"
        })
        setDone(true)
      }
    } catch (err) {
      const typedError = err as AxiosError
      const { code } = typedError.response?.data || {}
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  const handleSubmit = async (data, setError) => {
    const { firstName, lastName, nickName, birthday, genreId, email, password, code, subscribe, termsOfUse } = data
    gtag('event', 'step_3', {
      event_label: 'Registro - Email',
      method: "Email"
    })
    setLoad(true)
    try {
      const credentials = await createUserWithEmailAndPassword(auth, email, password)
      const utm = utmServices.utmRead()
      await ProfileService.signUp({ credentials, firstName, lastName, nickName, birthday, genreId, utm, code, subscribe, termsOfUse })
      setCredentials(credentials)
      localStorage.setItem('allowCookies', 'yes')
      setName(nickName)
      setEmail(email)
      setPassword(password)
      setOtp(true)
    } catch (error) {
      const typedError = error as AuthError
      if (typedError.code) {
        gtag('event', 'Click', {
          event_category: GTM_EVENT_CATEGORY,
          event_label: 'SINGUP - Error email existente',
          value: '10'
        })
        setError(typedError.code)
      } else if ((error as AxiosError).isAxiosError) {
        return setError((error as AxiosError).response?.data.code ?? 9999)
      }
    } finally {
      setLoad(false)
    }
  }

  if (error) return <ErrorView code={error} buttonMenu={() => setError(null)} onRetry={() => setError(null)} />

  if (done) return (
    <section className='w-full flex-1 flex flex-col items-center gap-4 p-7'>
      <div className='flex-1 flex flex-col items-center justify-center gap-6 w-full'>
        <TitleEmail className="text-center text-5xl font-bold uppercase mx-7 overflow-ellipsis overflow-hidden w-full">{textServices.findByText('mail/title', name ? <>Excelente<br />{name}</> : <>E-mail validado<br />con éxito</>)}</TitleEmail>
        <TextEmail className="din text-center mt-4 mx-7">{textServices.findByText('mail/description', <>Has confirmado con éxito tu cuenta.<br />Ya puedes ingresar</>)}</TextEmail>
      </div>
      <Button className='uppercase' onClick={handleLogin}>{textServices.findByText('mail/button', 'Ingresar')}</Button>
    </section>
  )

  if (otp) return <Welcome name={name} email={email} handleConfirm={handleConfirm} />

  return (
    <section className='flex w-full pt-7'>
      <FormInformation isSignUp={true} handleSubmit={handleSubmit} quantityStep={3} user={{ birthday } as any} />
    </section>)
}

export default SignUp
